import React from 'react';
import { Provider } from 'react-redux';
import AppRouter from "./routes/router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { store } from "./redux/store";

import './App.css'
import AppInitializer from './AppInitializer';

const App: React.FunctionComponent = () => {
  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <AppInitializer />
        <AppRouter />
      </I18nextProvider>
    </Provider>
  );
};

export default App;
